export default "__VITE_ASSET__CrJILPJ4__"